import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  if (param && JSON.stringify(param) !== '{}') {
    const { data, exec, isRequestSuccessed } = useRequest({
      name: 'GET_PRODUCT_LIST',
      url: '/api/products',
      manual: false,
    });

    useEffect(() => {
      if (param && JSON.stringify(param) !== '{}') {
        let url = '/api/products';
        let arr = [];
        Object.keys(param).forEach(key => {
          arr.push(key + '=' + param[key]);
        });
        if (arr.length !== 0) {
          url += '?' + arr.join('&');
        }
        exec(url);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [param]);
    return [data || [], exec, isRequestSuccessed];
  } else {
    const { data, exec, isRequestSuccessed } = useRequest({
      name: 'GET_PRODUCT_LIST',
      url: '/api/products',
      param,
    });
    return [data || [], exec, isRequestSuccessed];
  }
});
